import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';

export class SseMessageEvent extends SseEventBase {

  type: SseEventType = 'message';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.MESSAGE_ASSIGNED_TO_ME:
        case NotificationReasonEnum.MESSAGE_CREATED_BY_ME: {
          this.on.refreshProcessCountData$.next();
          break;
        }
      }
    });
  }
}
